import { Box, Flex } from "@chakra-ui/layout";
import { Row, Col } from "antd";
import {
  PessoaDto,
  TipoUnidadePessoaEnum,
} from "core/features/unidades/typings/unidade";
import { Control, UseFormWatch } from "react-hook-form";

import Field from "components/Input/Field";

import FormSelectMorador from "./FormSelectMorador";
import FormDadosPessoa from "./FormDadosPessoa";
import SwitchPodeParticiparVotacao from "./SwitchPodeParticiparVotacao";
import FormPermissao from "./FormPermissao";
import FormEndereco from "./FormEndereco";
import FormTipo from "./FormTipo";
import SelectPessoas from "components/Input/SelectPessoas";
import SelectTipoVinculoPessoa from "components/Input/SelectTipoVinculoPessoa";
import { TipoEntidadeEnum } from "resources/enums/conta";
import CollapseSwitch from "components/CollapseSwitch";

interface FormMoradorUnidadeProps {
  control: Control<PessoaDto, object>;
  watch: UseFormWatch<PessoaDto>;
  unidadeId: string;
  trigger: any;
  setField: any;
  tenantId: string;
  id?: string | null;
  hiddenTipo?: boolean;
  setLoadingUpload?: (loading: boolean) => void;
}

function FormMoradorUnidade({
  control,
  watch,
  unidadeId,
  trigger,
  setField,
  tenantId,
  hiddenTipo,
  id,
  setLoadingUpload,
}: FormMoradorUnidadeProps) {
  const tipoUnidadePessoaId = watch("tipoUnidadePessoaId");

  const moradorExistente = watch("moradorExistente");
  const pessoaId = watch("pessoaId");

  // TODO, foi removido isso pra corrigir bugs futuros
  // const isMaster =
  //   tipoUnidadePessoaId === TipoUnidadePessoaEnum.Proprietario ||
  //   tipoUnidadePessoaId === TipoUnidadePessoaEnum.Socio ||
  //   tipoUnidadePessoaId === TipoUnidadePessoaEnum.CoProprietario;
  const isOutros = tipoUnidadePessoaId === TipoUnidadePessoaEnum.Outros;

  return (
    <>
      {!hiddenTipo ? (
        <FormTipo control={control} trigger={trigger} watch={watch} />
      ) : null}

      {!id ? <FormSelectMorador control={control} watch={watch} /> : null}

      {moradorExistente === "n" ? (
        <FormDadosPessoa
          control={control}
          unidadeId={unidadeId}
          watch={watch}
          setLoadingUpload={setLoadingUpload}
        />
      ) : null}

      {moradorExistente === "s" && isOutros ? (
        <>
          <Box as={Row} gutter={16} mb={6}>
            <Box as={Col} md={10}>
              <Field
                shouldUnregister
                label="Vincular a uma pessoa"
                control={control}
                name="pessoaVinculadaId"
                rules={{ required: "Campo obrigatório" }}
                render={({ field, isInvalid }) => (
                  <SelectPessoas
                    {...field}
                    isInvalid={isInvalid}
                    tipoEntidades={[TipoEntidadeEnum.Condomino]}
                    unidadeId={unidadeId}
                    incluirPessoasComUnidade
                  />
                )}
              />
            </Box>

            <Box as={Col} md={14}>
              <Field
                label="Tipo do Vínculo"
                control={control}
                shouldUnregister
                name="tipoVinculoPessoaId"
                rules={{ required: "Campo obrigatório" }}
                render={({ field, isInvalid }) => (
                  <SelectTipoVinculoPessoa isInvalid={isInvalid} {...field} />
                )}
              />
            </Box>
          </Box>
        </>
      ) : null}

      {moradorExistente ? (
        <Box mb={6}>
          <Field
            shouldUnregister
            label="Observação"
            control={control}
            name="observacao"
            inputProps={{
              placeholder: "Escreva a observação...",
            }}
          />
        </Box>
      ) : null}

      {moradorExistente ? (
        <Box as={Row} gutter={36} mb={6}>
          <Box as={Col} xs={8}>
            <Field
              shouldUnregister
              label="Data de fim do acesso a unidade"
              control={control}
              name="dataFimAcesso"
              inputProps={{
                type: "date",
              }}
            />
          </Box>
        </Box>
      ) : null}

      {moradorExistente === "n" || (moradorExistente === "s" && pessoaId) ? (
        <Flex flexDir="column" gap="16px" mb={6}>
          <SwitchPodeParticiparVotacao
            control={control}
            watch={watch}
            setField={setField}
          />

          <FormEndereco control={control} watch={watch} setField={setField} />

          {/* {!isMaster ? ( */}
          <FormPermissao
            tenantId={tenantId}
            control={control}
            watch={watch}
            setField={setField}
          />

          {moradorExistente === "n" && !id ? (
            <Field
              control={control}
              name="enviarEmailAcesso"
              render={({ field }) => (
                <CollapseSwitch
                  onChange={(_) => {
                    field.onChange(field.value ? false : true);
                  }}
                  open={!!field.value}
                  title="Enviar email com dados de acesso?"
                />
              )}
            />
          ) : null}
        </Flex>
      ) : null}
    </>
  );
}

export default FormMoradorUnidade;
